import { Show } from "../FMAPI/show";

export class NewspaperRow {
    ShowTime: Date;
    Cells: NewspaperRow.Cell[];
}

export namespace NewspaperRow {

    export class Cell {
        Show: Show;
        Span: Number;
    }

}


// WEBPACK FOOTER //
// D:/OTHERS/FirstmediaShowSchedule/src/app/show-newspaper/newspaper-row.ts